import React, { useEffect, useState } from 'react';
import { AiOutlineLogout } from 'react-icons/ai';
import { useParams, useNavigate } from 'react-router-dom';
import { IoMdAdd } from 'react-icons/io';
import { familyDetailQuery } from '../utils/data';
import { client } from '../client';
import { v4 as uuidv4 } from 'uuid';
import { fetchUser } from '../utils/FetchUser';

const JoinFamily = ({ user }) => {
    const [family, setFamily] = useState(null);
    const [postHovered, setPostHovered] = useState(false);
    const [requestUserId, setRequestUserId] = useState();
    const { famId } = useParams();

    const navigate = useNavigate();

    useEffect(() => {
        setRequestUserId(user._id)
    }, [user])

    useEffect(() => {
        const query = familyDetailQuery(famId);
        client.fetch(query).then((data) => {
            setFamily(data[0]);
        });
    }, [famId]);

    const sendRequest = () => {
        console.log("request accepted");
        console.log(requestUserId);


        if (requestUserId) {
            console.log("request started");
            client
                .patch(famId)
                .setIfMissing({ requests: [] })
                .insert('after', 'requests[-1]', [{
                    _key: uuidv4(),
                    _ref: requestUserId,
                    _type: 'reference',
                }])
                .commit()
                .then((res) => {
                    console.log(res)
                    navigate('/');
                });
        }
        else
            console.log("request did not work");
    }

    return (
        <div className="relative pb-2 h-full justify-center items-center">
            <div className="flex flex-col pb-5">
                <div className="relative flex flex-col mb-7">
                    <div className="flex flex-col justify-center items-center">
                        <div
                            onMouseEnter={() => setPostHovered(true)}
                            onMouseLeave={() => setPostHovered(false)}
                            // onClick={() => navigate(`/pin-detail/${_id}`)}
                            className=" relative cursor-zoom-in w-auto hover:shadow-lg rounded-lg overflow-hidden transition-all duration-500 ease-in-out"
                        >
                            <img
                                className=" w-full h-100 2xl:h-51 shadow-lg object-cover"
                                src={family?.imageUrl + "?h=200"}
                                alt="user-pic"
                            />
                            {postHovered && (
                                <div
                                    className="absolute top-0 w-full h-full flex flex-col justify-between p-1 pr-2 pt-2 pb-2 z-50"
                                    style={{ height: '100%' }}
                                >
                                    <button>
                                        <IoMdAdd />
                                    </button>
                                </div>
                            )}
                        </div>
                    </div>
                    <h1 className="font-bold text-3xl text-center mt-3">
                        {family?.familyName}
                    </h1>
                    <div className="absolute top-0 z-1 right-0 p-2">

                        {user?.sub === family?.admin?._id && (
                            <>
                                <button
                                    type="button"
                                    className=" bg-white p-2 rounded-full cursor-pointer outline-none shadow-md"
                                >
                                    <AiOutlineLogout color="red" fontSize={21} />
                                </button>
                            </>
                        )}
                    </div>
                </div>
                <div className="text-center mb-7">
                    <button
                        type="button"
                        onClick={(e) => {
                            console.log(requestUserId);
                            sendRequest();
                        }}
                        className={`bg-indigo-500 text-white font-bold p-2 rounded-full w-20 outline-none`}
                    >
                        Join
                    </button>
                </div>
            </div>

        </div>
    )
}

export default JoinFamily